package one.healthium.carnivore.presentation.navigation.home.compose

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import ifaandroid.apps.carnivore.composeapp.generated.resources.Res
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_chat_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_insights_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_insights_selected
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_motivational_phrase_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_motivational_phrase_selected
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_profile_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_profile_selected
import kotlinx.coroutines.launch
import loco.MAIN_NAVIGATION_CHAT_LABEL
import loco.MAIN_NAVIGATION_DAILY_LABEL
import loco.MAIN_NAVIGATION_INSIGHTS_LABEL
import loco.MAIN_NAVIGATION_ME_LABEL
import one.healthium.carnivore.presentation.navigation.home.HomeComponent
import one.healthium.tasks.ui.DailyTasksBadge
import one.healthium.ui.compose.components.AppNavigationBarMinHeight
import one.healthium.ui.compose.components.AppNavigationRail
import one.healthium.ui.compose.components.AppNavigationRailItem
import one.healthium.ui.compose.components.LocalGlobalProgressIndicator
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun NavigationRail(component: HomeComponent) {
    val stack by component.stack.subscribeAsState()
    val activeComponent = stack.active.instance
    val scope = rememberCoroutineScope()
    val globalProgressIndicator = LocalGlobalProgressIndicator.current

    AppNavigationRail {
        // DailyTasks
        AppNavigationRailItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_tasks"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.DailyTasksChild) {
                    Res.drawable.ic_motivational_phrase_selected
                } else {
                    Res.drawable.ic_motivational_phrase_default
                }
                Box {
                    Icon(
                        painter = painterResource(resource),
                        contentDescription = null,
                    )
                    DailyTasksBadge(
                        modifier = Modifier
                            .align(Alignment.TopEnd)
                            .offset(x = 8.dp, y = (-8).dp),
                        borderStroke = BorderStroke(width = 1.dp, color = LocalContentColor.current),
                    )
                }
            },
            label = {
                Text(
                    text = stringResource(loco.Res.string.MAIN_NAVIGATION_DAILY_LABEL),
                )
            },
            selected = activeComponent is HomeComponent.Child.DailyTasksChild,
            onClick = component::onDailyTasksTabClicked,
        )

        // Insights
        AppNavigationRailItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_insights"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.MainContentChild) {
                    Res.drawable.ic_insights_selected
                } else {
                    Res.drawable.ic_insights_default
                }
                Icon(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            label = {
                Text(
                    text = stringResource(loco.Res.string.MAIN_NAVIGATION_INSIGHTS_LABEL),
                )
            },
            selected = activeComponent is HomeComponent.Child.MainContentChild,
            onClick = component::onMainContentTabClicked,
        )

        // Chat
        AppNavigationRailItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_chat"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.ChatChild) {
                    Res.drawable.ic_chat_default
                } else {
                    Res.drawable.ic_chat_default
                }
                Icon(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            label = {
                Text(
                    text = stringResource(loco.Res.string.MAIN_NAVIGATION_CHAT_LABEL),
                )
            },
            selected = activeComponent is HomeComponent.Child.ChatChild,
            onClick = {
                scope.launch {
                    globalProgressIndicator.value = true
                    component.onChatTabClicked()
                    globalProgressIndicator.value = false
                }
            },
        )

        // Profile
        AppNavigationRailItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_profile"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.ProfileChild) {
                    Res.drawable.ic_profile_selected
                } else {
                    Res.drawable.ic_profile_default
                }
                Icon(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            label = {
                Text(
                    text = stringResource(loco.Res.string.MAIN_NAVIGATION_ME_LABEL),
                )
            },
            selected = activeComponent is HomeComponent.Child.ProfileChild,
            onClick = component::onProfileTabClicked,
        )
    }
}